export default __webpack_public_path__ + "static/1874-bf352080b01132c76e52fbca1d0b52a6.gif";